// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4z-0";
export var eligibilityCardNotEligible = "_4z-1";